import React, { Component } from "react";

import "./project.css";
import { connect } from "react-redux";
import { locus, auth, project } from "../actions";

import { Tabs } from "antd";

import { changeTitle } from "../redux/actions";

import TransitionProject from "./transition_project";

import Physical_project from "./physical_project";

import MapProject from "./MapProject";

const { TabPane } = Tabs;

let options = [];

const VALUES = [
  "2021-1-02",
  "2021-1-01",
  "2021-2-01",
  "2021-3-01",
  "2021-4-01",
  "2021-5-01",
  "2021-6-01",
  "2021-7-01",
  "2021-8-01",
  "2021-9-01",
  "2021-10-01",
  "2021-11-01",
  "2021-12-01",
];

const ProjectOptions = [
  { key: "physical", value: "physical", text: "Physical Risk" },
  { key: "transition", value: "transition", text: "Transition Risk" },
  { key: "realestate", value: "realestate", text: "Real Estate" },
];
const StatusOptions = [
  { key: "active", value: "Active", text: "Active" },
  { key: "finished", value: "Finished", text: "Finished" },
];
const csv = [];
const othersOptions = [
  { key: "valuation", value: "valuation", text: "valuation" },
  { key: "type", value: "type", text: "type" },
  { key: "Area", value: "Area", text: "Area" },
  { key: "Ownership", value: "ownership", text: "Ownership" },
  { key: "floors", value: "floors", text: "floors" },
  {
    key: "Construction Cost",
    value: "construction_cost",
    text: "Replacement Value",
  },
  { key: "With Content", value: "with_content", text: "With Content" },
  { key: "Revenue", value: "revenue", text: "Revenue" },
];
let variableOptions = [];
const rcpOptions = [
  { key: "0.0", value: "0.0", text: "0.0" },
  { key: "2.6", value: "2.6", text: "2.6" },
  { key: "4.5", value: "4.5", text: "4.5" },
  { key: "8.5", value: "8.5", text: "8.5" },
];
const yearOptions = [
  { key: "2020", value: "2020", text: "2020" },
  { key: "2030", value: "2030", text: "2030" },
  { key: "2050", value: "2050", text: "2050" },
];
const PortfolioLossOptions = [
  {
    key: "Rainfall Flood Loss",
    value: "Rainfall Flood Loss",
    text: "Rainfall Flood Loss",
  },
  {
    key: "River Flood Loss",
    value: "River Flood Loss",
    text: "River Flood Loss",
  },
  {
    key: "Storm Surge Loss",
    value: "Storm Surge Loss",
    text: "Storm Surge Loss",
  },
  { key: "Typhoon Loss", value: "Typhoon Loss", text: "Typhoon Loss" },
  {
    key: "Temprature/heat Loss",
    value: "Temprature/heat Loss",
    text: "Temprature/heat Loss",
  },
  /*{
    key: "Solar Production Loss",
    value: "Solar Production Loss",
    text: "Solar Production Loss",
  },
  {
    key: "Wind Production Loss",
    value: "Wind Production Loss",
    text: "Wind Production Loss",
  },
  {
    key: "Hydro Production Loss",
    value: "Hydro Production Loss",
    text: "Hydro Production Loss",
  },
  {
    key: "Wheat Production Loss",
    value: "Wheat Production Loss",
    text: "Wheat Production Loss",
  },
  {
    key: "Rice Production Loss",
    value: "Rice Production Loss",
    text: "Rice Production Loss",
  },
  {
    key: "Maize Production Loss",
    value: "Maize Production Loss",
    text: "Maize Production Loss",
  },
  {
    key: "Fruit Production Loss",
    value: "Fruit Production Loss",
    text: "Fruit Production Loss",
  },
  {
    key: "Vegetable Production Loss",
    value: "Vegetable Production Loss",
    text: "Vegetable Production Loss",
  },*/
];

class Project extends Component {
  state = {
    project_type: "physical",
    tier_data: null,
  };
  componentDidMount() {
    // Initial load from localStorage
    this.loadTierData();

    // Listen for tier data update events
    window.addEventListener("tierDataUpdated", this.loadTierData);
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener("tierDataUpdated", this.loadTierData);
  }

  loadTierData = () => {
    try {
      const tierdata = JSON.parse(localStorage.getItem("tier_data"));
      this.setState({ tierdata }, () => {
        console.log("tierdata from localStorage:", this.state.tierdata);
      });
    } catch (e) {
      console.error("Invalid tier_data in localStorage:", e);
      this.setState({ tierdata: null });
    }
  };

  handleProject = (key) => {
    this.setState({ project_type: key }, () =>
      console.log("project type", this.state.project_type)
    );
  };

  render() {
    return (
      <>
        <br />
        <br />
        <Tabs
          defaultActiveKey="physical"
          onChange={this.handleProject}
          style={{ paddingLeft: "1.5%" }}
          destroyInactiveTabPane
        >
          <TabPane tab="Physical Risk" key="physical">
            {this.state.project_type === "physical" && (
              <Physical_project key="physical" />
            )}
          </TabPane>

          <TabPane tab="Transition Risk" key="transition">
            <TransitionProject />
          </TabPane>

          <TabPane tab="Maps" key="map_module">
            <MapProject />
          </TabPane>
        </Tabs>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.project.errors,
    locus: state.locus.locus,
    csv: state.project.csv,
    project: state.project.project,
    ppt: state.project.ppt,
    map: state.project.map,
    overall_map: state.project.overall_map,
    link: state.project.link,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getLocations: () => {
      dispatch(locus.getLocations());
    },
    logout: () => {
      dispatch(auth.logout());
    },
    addProject: (formdata) => {
      dispatch(project.addProject(formdata));
    },
    getCSV: (formdata) => {
      dispatch(project.getCSV(formdata));
    },
    getLoss: (formdata) => {
      dispatch(project.getLoss(formdata));
    },
    getSummary: (formdata) => {
      dispatch(project.getSummary(formdata));
    },
    changeTitle: (title) => {
      dispatch(changeTitle(title));
    },
    getProjects: () => {
      dispatch(project.getProjects());
    },
    deleteProject: (formdata) => {
      dispatch(project.deleteProject(formdata));
    },
    getPptReport: (formdata) => {
      dispatch(project.getPptReport(formdata));
    },
    getSatelliteMap: (formdata) => {
      dispatch(project.getSatelliteMap(formdata));
    },
    getMap: (formdata) => {
      dispatch(project.getMap(formdata));
    },
    Dropbox: (formdata) => {
      dispatch(project.Dropbox(formdata));
    },
    getProjectList: (physical_risk) => {
      dispatch(project.getProjectList(physical_risk));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Project);
